import React from 'react'
import HistoricalContainer from './HistoricalContainer'

const Historical = () => <HistoricalContainer data-test="component-tradeIn-historical" />

export default Historical
